import * as React from "react"

export default function AttendeesIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.667 7.333a3 3 0 110-6 3 3 0 010 6zm7 2.667a2.667 2.667 0 110-5.333 2.667 2.667 0 010 5.333zm0 .667a3 3 0 013 3V14h-6v-.333a3 3 0 013-3zM4.667 8A3.333 3.333 0 018 11.333V14H1.333v-2.667A3.333 3.333 0 014.667 8z"
        fill={props.fill}
      />
    </svg>
  )
}
